import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_USER_TASK_LIST = 'GET_USER_TASK_LIST';


export const service = async (data) => {
  const options: object = {
    url:  '/Api/UserTasks/GetManagerViewTaskList',
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = await callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_USER_TASK_LIST, service, mock);
